import {action, makeAutoObservable} from "mobx"
import PriceSettingsApi, {IComparePrice} from "../../api/PriceSettingsApi"
import CategoryWithMarkUp from "../entities/priceMarkup/CategoryWithMarkUp"
import {CommandData} from "../../utils/RequestsHelper";


class PriceUpdateController {
    constructor() {
        makeAutoObservable(this)
    }

    private _markUps: CategoryWithMarkUp[] | undefined
    private _total_count = -1
    private _page = 0
    private _pageCount = 100
    private _countOfPages = 0
    private _loadStarted = false

    get countOfPages(): number {
        return this._countOfPages
    }

    get loadStarted(): boolean {
        return this._loadStarted
    }

    get pageCount(): number {
        return this._pageCount
    }

    get page(): number {
        return this._page
    }

    get markUps(): CategoryWithMarkUp[] | undefined {
        return this._markUps
    }

    private _syncPrices: CommandData | undefined

    get syncPrices(): CommandData | undefined {
        return this._syncPrices
    }

    private _units: { label: string, value: string }[] = []

    get units(): { label: string; value: string }[] {
        return this._units
    }

    prices: IComparePrice[] = []

    get pricesLoaded(): boolean {
        return this.prices && this.prices.length > 0
    }

    private _search_query: string = ""

    get search_query(): string {
        return this._search_query
    }

    get totalCount(): number {
        return this._total_count
    }

    set search_query(value: string) {
        this._search_query = value
        this.comparePrices()
    }

    private _not_found: boolean = false

    get not_found(): boolean {
        return this._not_found
    }

    set not_found(value: boolean) {
        this._not_found = value
        this.comparePrices()
    }
    
    private _with_diff: boolean = false

    get with_diff(): boolean {
        return this._with_diff
    }

    set with_diff(value: boolean) {
        this._with_diff = value
        this.comparePrices()
    }


    loadSettings() {
        PriceSettingsApi.getMarkupsByCategories().then(action("loaded", (answer) => {
            const markups = answer.data.data.markups
            this._units = answer.data.data.units
            this._syncPrices = answer.data.data.syncPrice
            const loadedMarkups = []
            for (const markup of markups) {
                loadedMarkups.push(new CategoryWithMarkUp(markup))
            }
            this._markUps = loadedMarkups
        }))
    }

    getOptionByUnit(value: string): { label: string, value: string } {
        for (const unit of this._units) {
            if (value === unit.value) {
                return unit
            }
        }
        throw new Error("Unit Not Fount")
    }

    comparePrices(page=0, start=false) {
        if (+this._page === +page && this._loadStarted) {
            return false
        }
        this._loadStarted = true
        this._page = page
        PriceSettingsApi.comparePrices({
            page:this._page,
            filter:this._not_found,
            with_diff:this._with_diff,
            query:this._search_query,
            pageCount: this._pageCount,
            start: start
        }).then(action("comparePricesDone",(result) => {
            this._loadStarted = false
            this.prices = result.data.data.prices
            this._countOfPages = result.data.data.totalPages
            if(this._total_count === -1) {
                this._total_count = this._countOfPages * this._pageCount
            }
            console.log(this.totalCount)
        }))
    }
}

const priceUpdateController = new PriceUpdateController()
export default priceUpdateController